var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 288 216",
    viewBox: "0 0 288 216",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#a);}\n\t.st1{fill:#4985A4;}\n\t.st2{fill:url(#SVGID_00000173139520721164143480000016973157783365365128_);}\n\t.st3{fill:#055569;}\n\t.st4{fill:url(#SVGID_00000016042924913770681350000006896821345789018498_);}\n\t.st5{fill:#38663D;}\n\t.st6{fill:url(#SVGID_00000075157773116674921800000018323421356431730603_);}\n\t.st7{fill:#1A502C;}\n\t.st8{fill:none;}\n\t.st9{fill:url(#SVGID_00000111153052763951733790000002820828314901409192_);}\n\t.st10{fill:#5F425F;}\n\t.st11{fill:url(#SVGID_00000096778227107484597670000013882972024096326538_);}\n\t.st12{fill:#1F0726;}\n\t.st13{fill:url(#SVGID_00000157993483097920116420000013226851582626758301_);}\n\t.st14{fill:url(#SVGID_00000011720204128397509730000016030128996418165387_);}\n\t.st15{fill:url(#SVGID_00000059286935457622270640000014498011290545674372_);}\n\t.st16{fill:url(#SVGID_00000008147851983414456870000015783402048634305971_);}\n\t.st17{fill:url(#SVGID_00000098215345156524969330000014802550720104452012_);}\n\t.st18{fill:url(#SVGID_00000012466215010992786850000014463837144428687544_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3267 0 0 1.3632 -46.854 16.681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.88 59.4c0-9.06-4.53-13.59-13.59-13.59h-13.59v38.04h13.59c9.06 0 13.59-4.53 13.59-13.59zm-5.44 10.87c0 5.43-2.72 8.15-8.15 8.15h-8.15v-27.17h8.15c5.43 0 8.15 2.72 8.15 8.15zm35.33 8.15h-19.02v-13.58h16.3v-5.44h-16.3v-8.15h19.02v-5.43h-24.45v38.04h24.45zm27.17 0h-16.3v-32.6h-5.43v38.04h21.74v-5.44zm23.8-32.6-10.22 29.62-10.22-29.62h-5.73l13.07 37.96 0.03 0.08h5.71l0.03-0.08 13.07-37.96zm33.26 32.6h-19.02v-13.58h16.3v-5.44h-16.3v-8.15h19.02v-5.43h-24.45v38.04h24.45zm-137.71 9.74h-3.58v10.03h1.43v-2.86h2.15c2.39 0 3.58-1.19 3.58-3.58 0-2.4-1.2-3.59-3.58-3.59zm0 5.72h-2.15v-4.3h2.15c1.43 0 2.15 0.72 2.15 2.15-0.01 1.44-0.72 2.15-2.15 2.15zm6.44-5.72h-1.43v10.03h5.73v-1.43h-4.3zm10.06 0h-1.5l-0.01 0.02-3.44 10h1.51l0.74-2.15h3.91l0.74 2.15h1.51l-3.44-10zm-2.21 6.44 1.46-4.23 1.46 4.23zm12.2-2.15-4.3-4.3h-1.43v10.03h1.43v-7.99l4.3 4.3v3.7h1.43v-10.03h-1.43zm8.6 0-4.3-4.3h-1.43v10.03h1.43v-7.99l4.3 4.3v3.7h1.43v-10.03h-1.43zm2.86 5.73h1.43v-10.02h-1.43zm8.6-5.73-4.3-4.3h-1.43v10.03h1.43v-7.99l4.3 4.3v3.7h1.43v-10.03h-1.43zm5.72 0.72h2.86v1.43c0 1.43-0.72 2.15-2.15 2.15s-2.15-0.72-2.15-2.15v-2.86c0-1.43 0.72-2.15 2.15-2.15 0.72 0 1.25 0.18 1.61 0.54l1.07-1.07c-0.6-0.6-1.49-0.9-2.69-0.9-2.39 0-3.58 1.19-3.58 3.58v2.86c0 2.39 1.19 3.58 3.58 3.58s3.58-1.19 3.58-3.58v-2.86h-4.3v1.43zm12.93-5.01h-1.5l-0.01 0.02-3.44 10h1.51l0.74-2.15h3.91l0.74 2.15h1.51l-3.44-10zm-2.21 6.44 1.46-4.23 1.46 4.23zm13.63-2.86c0-2.39-1.19-3.58-3.58-3.58h-3.58v10.03h1.43v-2.86h2.06l1.65 2.86h1.65l-1.76-3.05c1.42-0.43 2.13-1.56 2.13-3.4zm-3.58 2.14h-2.15v-4.3h2.15c1.43 0 2.15 0.72 2.15 2.15 0 1.44-0.72 2.15-2.15 2.15zm8.6-4.29c1.43 0 2.15 0.72 2.15 2.15h1.43c0-2.39-1.19-3.58-3.58-3.58s-3.58 1.19-3.58 3.58v2.86c0 2.39 1.19 3.58 3.58 3.58s3.58-1.19 3.58-3.58h-1.43c0 1.43-0.72 2.15-2.15 2.15s-2.15-0.72-2.15-2.15v-2.86c0-1.44 0.71-2.15 2.15-2.15zm10.74 2.15h-4.3v-3.58h-1.43v10.03h1.43v-5.01h4.3v5.01h1.43v-10.03h-1.43zm2.86 6.44h1.43v-10.02h-1.43zm2.87-8.59h2.86v8.59h1.43v-8.59h2.86v-1.43h-7.16v1.43zm8.59 8.59h6.45v-1.43h-5.01v-3.58h4.3v-1.43h-4.3v-2.15h5.01v-1.43h-6.45zm11.46-8.59c1.43 0 2.15 0.72 2.15 2.15h1.43c0-2.39-1.19-3.58-3.58-3.58s-3.58 1.19-3.58 3.58v2.86c0 2.39 1.19 3.58 3.58 3.58s3.58-1.19 3.58-3.58h-1.43c0 1.43-0.72 2.15-2.15 2.15s-2.15-0.72-2.15-2.15v-2.86c0-1.44 0.72-2.15 2.15-2.15zm4.3 0h2.86v8.59h1.43v-8.59h2.86v-1.43h-7.16v1.43zm12.39 3.08c-1.91-0.62-2.86-1.17-2.86-1.65 0-0.95 0.72-1.43 2.15-1.43s2.15 0.6 2.15 1.79h1.42c0-2.15-1.19-3.22-3.58-3.22s-3.58 0.95-3.58 2.86c0 1.15 0.95 2.03 2.86 2.65s2.86 1.17 2.86 1.65c0 0.95-0.72 1.43-2.15 1.43s-2.15-0.6-2.15-1.79h-1.43c0 2.15 1.19 3.22 3.58 3.22s3.58-0.95 3.58-2.86c0.01-1.15-0.94-2.03-2.85-2.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 59.849,
    x2: 101.45,
    y1: 78.861,
    y2: 78.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6B84",
    offset: 1.3189e-7
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055569",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6B84",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m77.21 84.97-17.36 9.23v-8.52l17.36-9.24v2.73l3.89 2.09-3.89 1.98zm24.24-21.44-9.04 4.81v8.73l9.04-4.7z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m59.85 85.68v8.52l-10.13-5.81v-8.55zm-13.72-8.01-10.13-5.92v8.76l10.13 5.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36,
    x2: 101.45,
    y1: 69.766,
    y2: 69.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E97BA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4985A4",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E97BA",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.13 77.67-10.13-5.92 16.67-8.64v8.47l-1.12 0.51 2.47 1.38zm55.32-14.14-10.04-5.86-6.53 3.47v1.68l7.53 4.37v1.15zm-41.6 22.15 17.36-9.24v-0.56l-7.17-4.07-9.86 5.11-2.41-1.35-8.03 4.27zm25.03-31.83v3.24l2.91-1.55z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m49.72 79.84v4.58l-3.59 1.91v-8.66l7.89-4.19v4.07zm38.07-24.29-2.91 1.55v4.04l2.91-1.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 58.821,
    x2: 78.893,
    y1: 40.231,
    y2: 74.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9C6C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#538052",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9C6C",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.4 61.36 2.17-1.16v-4.03l3.59 2.11 1.5-0.8 16.75 9.71-7.53 3.67zm-15.73-17.22-7.36 3.89 7.99 4.61 7.01-4.08z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m92.41 83.5v12.34l-7.53 4.01v-12.5zm0-3.88v-12.43l-7.53 3.67v12.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 45.303,
    x2: 84.875,
    y1: 73.946,
    y2: 73.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#538052",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38663D",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#538052",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.96 64.52-4.66-2.5v-13.98l7.99 4.61-0.63 0.37v10.11zm34.92 6.34-16.48-9.5-0.65 0.35v8.81l9.46 5.36v3.29l7.67 4.12zm-39.58-3.93 0.79-0.41-0.79-0.42zm31.91 16.3v3.24l-1.33-0.78-8.11 4.3 17.11 9.87v-12.51z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m84.88 87.35-7.67-4.12 3.89-1.98 3.78 2.03 3.77-1.83 3.76 2.05zm-34.92-22.83-0.78-0.42-3.88 2 0.79 0.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "52.67 52.28 68.4 61.36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 56.257,
    x2: 56.257,
    y1: 104.73,
    y2: 53.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#492C49",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341736",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#492C49",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m59.85 76.74-2.1-1.17-3.73 1.98v-4.07l-1.36-0.76v-19.71l7.18 4.14v19.59zm0 17.46-7.14-4.1v10.55l7.14 4.08z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m74.16 49.11-7.16-4.21 10.93-5.63 6.95 4.07zm-3.59 1.94-6.98-4.39-10.92 6.35 7.18 4.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 82.199,
    x2: 62.526,
    y1: 93.339,
    y2: 54.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341736",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0726",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341736",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.16 97.18v-3.5l3.17 1.83zm-14.31-40.03v19.58l0.32 0.18 7.58-3.92v-11.29l2.82-1.51v-9.15zm25.03 5.67v-19.48l-10.72 5.77v9.17l2.64-1.41v1.27zm-15.75 27.95-1.38 0.69 0.02-1.47-7.92 4.21v10.53l10.72-5.66v-7.47z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m74.16 58.28-3.59-2.11v-5.12l-3.57-2.25v-3.9l7.16 4.21zm0 35.39-3.59-2.07v3.46l3.59 2.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.67 71.59 52.67 72.72 51.55 72.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.75 91.46 69.13 90.77 67.77 89.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.21 86.47 75.87 85.69 77.21 84.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.66 57.48 76.8 58.14 76.8 56.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.75 72.99 67.75 70.52 70.03 71.81"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosvg);
export default __webpack_public_path__ + "static/media/logosvg.2bc9ac2addd3757b465bf009276ae4c4.svg";
export { ForwardRef as ReactComponent };